<template>
  <div
    class="profile-tabs"
    :class="{'profile-tabs_more-than-two': tabsMoreThanTwo}"
  >
    <div
      v-for="link in profileLinks"
      :key="link.to"
      class="profile-tabs__item-wrapper"
      :class="{'profile-tabs__item-wrapper_active': isItemActive(link.to) && tabsMoreThanTwo}"
    >
      <router-link
        :to="{ name: link.to, path: link.path }"
        class="profile-tabs__item"
      >
        {{ link.name }}
      </router-link>
    </div>
  </div>
</template>


<script>
import store from "../../store";

export default {
  data() {
    return {
      innerWidth: null,
      showDocumentsTab: false,
    }
  },
  methods: {
    setActiveLinkOrderForMobile(routeName) {
      return this.isMobile() && this.isItemActive(routeName) && this.tabsMoreThanTwo ?
        `order: ${this.profileLinks.length}` :
        false;
    },
    isItemActive(routeName) {
      return routeName === this.$route.name;
    },
    isMobile() {
      return this.innerWidth <= 500;
    },
    handleWindowResize() {
      this.innerWidth = window.innerWidth;
    }
  },
  computed: {
    profileLinks() {
      const profileLinks = [];

      //profileLinks.push({path: '/products/compact-crush', name: 'Продукты'});
      if (store.getters.isStandardLinkVisible) {
        profileLinks.push({to: 'profile', name: 'Личные данные'});
      }
      //profileLinks.push({to: 'activity', name: 'Прогресс'});
      if (store.getters.isDocumentsTabVisible) {
        profileLinks.push({to: 'profile-documents', name: 'Документы'});
      }
      //profileLinks.push({to: 'profile-password', name: 'Смена пароля'});
      profileLinks.push({to: 'profile-delete', name: 'Действия с анкетой'});
      if (store.getters.isStandardLinkVisible) {
        profileLinks.push({to: 'profile-subscribe', name: 'Подписки'});
      }

      return profileLinks;
    },
    tabsMoreThanTwo() {
      return this.profileLinks.length > 2;
    }
  },
  async mounted() {
    window.addEventListener('resize', this.handleWindowResize);
    this.handleWindowResize();
  }
}
</script>

<style lang="scss">
@import "../../scss/base/_settings.scss";

@mixin mobile-tabs {
  @media screen and (max-width: 500px) {
    @content;
  }
}

.profile-tabs {
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  column-gap: 32px;
  margin-bottom: 32px;
  text-align: left;
  border-bottom: 1px solid $input-border;
  text-transform: uppercase;
  font-size: 25px;
  line-height: 1.3;
  @include mobile {
    font-size: 18px;
    margin-bottom: 20px;
  }
  @include mobile-tabs {
    &_more-than-two {
      flex-wrap: wrap;
      justify-content: flex-start;
    }
  }

  &__item-wrapper {
    &_active {
      @include mobile-tabs {
        width: 100%;
      }
    }
  }

  &__item {
    display: inline-block;
    position: relative;
    padding-bottom: 5px;
    color: $text-light;
    text-decoration: none;

    &.router-link-exact-active {
      color: $brand-color;
      &::after {
        content: "";
        display: block;
        position: absolute;
        bottom: -2px;
        width: 100%;
        height: 2px;
        border-radius: 1px;
        background: $brand-color;
      }
    }
  }
}
</style>
